import cn from 'classnames';
import { PropsWithChildren } from 'react';

import styles from './Item.module.scss';

interface ItemProps {
  label: string;
  value?: string | JSX.Element;
  className?: string;
}

export function Item({ label, value, className, children }: PropsWithChildren<ItemProps>) {
  return (
    <div className={styles.wrapper}>
      <p className={styles.label}>{label}</p>
      {value && <p className={cn(styles.value, className)}>{value}</p>}
      {children && children}
    </div>
  );
}
